import React from 'react';
import PropTypes from 'prop-types';
import { Marker } from 'react-map-gl';

import { useSelector } from 'react-redux';

import { selectCurrentStation, selectViewState } from '../../../store/map/map.selector';


import stations from '../../../store/constants/stations.json';

import { ReactComponent as StationIcon } from './station_icon.svg';

export default function StationMarkers({ openMarker, closeMarker, clickMarker }) {
  const viewState = useSelector(selectViewState);
  const currentStation = useSelector(selectCurrentStation);

  const viewableLocations = stations.filter(
    (loc) =>
      loc.lat < viewState.latitude + 1.52 &&
      loc.lat > viewState.latitude - 1.52 &&
      loc.lng < viewState.longitude + 4.41 &&
      loc.lng > viewState.longitude - 4.41
  );

  return viewableLocations.map((loc) => {
    return (
    <Marker key={loc.sid + loc.name} latitude={loc.lat} longitude={loc.lng} anchor='bottom'>
      <div
        onMouseEnter={() => openMarker(loc.lat, loc.lng, loc.name)}
        onMouseLeave={closeMarker}
        onClick={(e) => clickMarker(e, loc)}
        className='marker'
      >
        <StationIcon fill='none' stroke={loc.sid === currentStation.sid ? 'red' : 'black'} />
      </div>
    </Marker>
  );
    });
}

StationMarkers.propTypes = {
  openMarker: PropTypes.func,
  closeMarker: PropTypes.func,
  clickMarker: PropTypes.func,
  selectedMarker: PropTypes.string
};